import { render, staticRenderFns } from "./ListFlowruns.vue?vue&type=template&id=20c4e834&scoped=true&"
import script from "./ListFlowruns.vue?vue&type=script&lang=js&"
export * from "./ListFlowruns.vue?vue&type=script&lang=js&"
import style0 from "./ListFlowruns.vue?vue&type=style&index=0&id=20c4e834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c4e834",
  null
  
)

export default component.exports